import { render, staticRenderFns } from "./TouchTargetsModule.vue?vue&type=template&id=5ec2a574&"
import script from "./TouchTargetsModule.vue?vue&type=script&lang=js&"
export * from "./TouchTargetsModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports